<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Region</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="region.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="region.desc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-autocomplete
              label="Alpha Main Region"
              :class="classPadding"
              v-model="region.alphaMainRegCode"
              :items="mainRegions"
              item-text="alphaRegMainRegionDesc"
              item-value="alphaRegMainRegion"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
        <template slot="details" slot-scope="{ item }">
          <v-btn @click.stop="viewDetails(item)" text outlined>View</v-btn>
        </template>
      </list>
      <!-- <router-view /> -->

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editRegion.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editRegion.desc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
                <v-autocomplete
                  label="Alpha Main Region"
                  :class="classPadding"
                  v-model="editRegion.alphaMainRegCode"
                  :items="mainRegions"
                  item-text="alphaRegMainRegionDesc"
                  item-value="alphaRegMainRegion"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
            </v-row>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="detailsDialog" width="900" persistent scrollable>
      <v-card>
        <v-card-title>
          <span>Region Setup Details</span>
        </v-card-title>
        <v-card-text>
          <br />
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                readonly
                v-model="selectedDetails.alphaRegCode"
                label="Code"
                :class="classPadding"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                readonly
                v-model="selectedDetails.alphaRegDesc"
                label="Description"
                :class="classPadding"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                v-model="selectedDetails.alphaRegMWEValue"
                label="Minimum Wage"
                type="number"
                :class="classPadding"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <custom-datepicker
                label="Effectivity Date"
                v-model="selectedDetails.alphaRegEffectivityDate"
                :required="true"
                :class-padding="classPadding"
              ></custom-datepicker>
            </v-col>
            <v-col :class="classPadding" cols="12" xs="12" sm="12" md="12">
              <v-btn
                color="success"
                @click.stop="addDetails"
                :class="classPadding"
                :loading="detailsLoading"
                >Add</v-btn
              >
            </v-col>
          </v-row>
          <v-data-table :headers="detailsHeader" :items="details">
            <template v-slot:item.actions="{ item }">
              <v-btn @click.stop="editDetails(item)" text icon>
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
              <v-btn @click.stop="deleteDetails(item)" text icon>
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.alphaRegEffectivityDate="{ item }">
              <span>{{ item.alphaRegEffectivityDate | dateFormat }}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="detailsDialog = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDetailsDialog" width="600" persistent scrollable>
      <v-card>
        <v-card-title>
          <span>Edit Details</span>
        </v-card-title>
        <v-card-text>
          <br />
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                v-model="editSelectedDetails.alphaRegMWEValue"
                label="Minimum Wage"
                type="number"
                :class="classPadding"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <custom-datepicker
                label="Effectivity Date"
                v-model="editSelectedDetails.alphaRegEffectivityDate"
                :required="true"
                :class-padding="classPadding"
              ></custom-datepicker>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.prevent="editDetailsDialog = false" text color="error"
            >close</v-btn
          >
          <v-btn @click.prevent="updateDetails" text color="success"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import CustomDatepicker from "../../../../components/CustomDatepicker";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/region";
export default {
  metaInfo: {
    title: "Region",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List,
    CustomDatepicker
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    region: {},
    componentKey: 0,
    editRegion: {},
    editDialog: false,
    mainRegions: [],
    detailsDialog: false,
    selectedDetails: {},
    detailsHeader: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "alphaRegCode",
        sortable: true
      },
      {
        text: "Minimum Wage",
        value: "alphaRegMWEValue",
        sortable: false
      },
      {
        text: "Effectivity Date",
        value: "alphaRegEffectivityDate",
        sortable: false
      }
    ],
    details: [],
    editSelectedDetails: {},
    detailsLoading: false,
    editDetailsDialog: false
  }),
  methods: {
    // ...mapActions("movementTypeDetails", ["selectMovementTypeDetails"]),
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.region)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editRegion.code = rel.alphaRegCode;
      this.editRegion.desc = rel.alphaRegDesc;
      this.editRegion.alphaMainRegCode = rel.alphaRegMainRegion;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.alphaRegCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.region = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editRegion)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    getAllMainRegion() {
      this.$axios
        .get(`${API_ENDPOINT}/main`)
        .then(({ data }) => {
          this.mainRegions = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    viewDetails(item) {
      this.detailsDialog = true;
      this.selectedDetails = Object.assign({}, item);
      this.getDetails(this.selectedDetails.alphaRegCode);
    },
    getDetails(regCode) {
      this.$axios
        .get(`${API_ENDPOINT}/details/${regCode}`)
        .then(({ data }) => {
          this.details = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    addDetails() {
      this.detailsLoading = true;
      this.$axios
        .post(`${API_ENDPOINT}/details`, this.selectedDetails)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.getDetails(this.selectedDetails.alphaRegCode);
          this.resetDetails();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.detailsLoading = false;
        });
    },
    editDetails(item) {
      this.editSelectedDetails = Object.assign({}, item);
      this.editDetailsDialog = true;
    },
    deleteDetails(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/details`, {
              data: {
                alphaRegId: item.alphaRegId,
                payAlphaRegId: item.payAlphaRegId
              }
            })
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.getDetails(this.selectedDetails.alphaRegCode);
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    updateDetails() {
      this.$axios
        .put(`${API_ENDPOINT}/details`, this.editSelectedDetails)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.getDetails(this.selectedDetails.alphaRegCode);
          this.editDetailsDialog = false;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    resetDetails() {
      this.selectedDetails.alphaRegMWEValue = 0;
      this.selectedDetails.alphaRegEffectivityDate = null;
    }
  },
  created() {
    this.getAllMainRegion();
    this.getUserAccessRights("Region");
  }
};
</script>